import { render, staticRenderFns } from "./BroadcastList.vue?vue&type=template&id=dc16d88e&scoped=true"
import script from "./BroadcastList.vue?vue&type=script&lang=js"
export * from "./BroadcastList.vue?vue&type=script&lang=js"
import style0 from "./BroadcastList.vue?vue&type=style&index=0&id=dc16d88e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc16d88e",
  null
  
)

export default component.exports